import React, { createContext, ReactNode, useContext, useEffect } from 'react';
import {
  Metadata,
  TListOption,
  useGetOptionStartInspection
} from 'hooks/useGetOptionStartInspection';
import { SingleEntryField } from 'services/option';
import { useGetUser, UserSelectOption } from 'hooks/useGetUser';
import { StorageServices } from 'services/storage';

export const RoomContext = createContext<{
  systemDropdownValues?: Metadata;
  listOption?: TListOption;
  users?: UserSelectOption[];
  singleEntryField?: SingleEntryField[];
  refreshOptions?: () => Promise<void>;
}>({
  systemDropdownValues: undefined,
  singleEntryField: undefined,
  users: [],
  listOption: undefined,
  refreshOptions: undefined
});
const storage = new StorageServices();

export const RoomProvider = ({ children }: { children: ReactNode }) => {
  const token = storage.getAccessToken();
  const { systemDropdownValues, singleEntryField, listOption, refreshOptions } =
    useGetOptionStartInspection();
  const { users, getUsers } = useGetUser();
  useEffect(() => {
    if (!token) return;
    getUsers();
  }, [token, getUsers]);
  return (
    <RoomContext.Provider
      value={{
        systemDropdownValues,
        singleEntryField,
        users,
        listOption,
        refreshOptions
      }}>
      {children}
    </RoomContext.Provider>
  );
};

export const useRoomContext = () => useContext(RoomContext);
